<template>
    <div>
        <drop
            @dragover="function(transfer_data, nativeEvent) {
                highlightDropArea(value, transfer_data)
            }"
            @dragleave="unhighlightDropArea(value)"
            @drop="function(transfer_data, nativeEvent) {
                handleDrop(value, transfer_data)
                unhighlightDropArea(value)
            }"
            class="drop"
        >
            <multiselect
                v-model="selected_standards"
                :options="sorted_standards"
                :close-on-select="false"
                :class="{'highlight': selected_standards.highlight}"
                label="number"
                track-by="number"
                multiple
                @select="addStandard"
                @remove="removeStandard"
                :disabled="!can_add_standard || disabled"
            >
                <template #option="{ option }">
                    <div class="option__desc d-flex align-items-center">
                        <span class="option__title mr-1">{{option.number}} ( {{ option.year }} ) </span>
                        <span class="mr-1" v-if="option.description"> - {{option.description}}</span>
                        <span v-if="option.year">({{option.year}})</span>
                    </div>
                </template>
                <template #tag="{ option }">
                    <span class="multiselect__tag">
                        <span v-if="option.extended_description" :content="option.extended_description" v-tippy>{{ option.number }}</span>
                        <span v-else
                            :content="option.description"
                            v-tippy="{ placement: 'top' }"
                        >
                            {{ option.number }} ({{ option.year }})
                        </span>
                        <a tabindex="1" class="multiselect__tag-icon text-white" @click="removeStandard(option)"></a>
                    </span>
                </template>
            </multiselect>
        </drop>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
import { mapState } from 'vuex'

export default {
    data: () => ({}),
    props: [
        'value',
        'standards',
        'disabled',
        'state_grade'
    ],
    computed: {
        ...mapState({
            user: state => state.user.user
        }),
        selected_standards: {
            get () {
                if (this.value) {
                    if(!this.state_grade){
                        return this.value
                    }
                    else{
                        let filtered_standards = [];
                        _.forEach(this.value, standard => {
                            if(
                                this.state_grade.state == standard.state
                                &&
                                this.state_grade.grade <= standard.high_grade
                                &&
                                this.state_grade.grade >= standard.low_grade
                            ){
                                filtered_standards.push(standard);
                            }    
                        })
                        return filtered_standards;
                    }
                    
                    
                } else {
                    return []
                }
            },
            set () {}
        },
        sorted_standards: {           
            get () {
                return _.orderBy(this.standards, 'number')
            },
            set () {}
        },
        can_add_standard(){
            return this.user && this.user.permissions && _.includes(this.user.permissions, 'add_standard');
        }
    },
    components: {},
    methods: {
        addStandard (event) {
            this.$emit('addStandard', event)
        },
        removeStandard (event) {
            this.$emit('removeStandard', event)
        },
        handleDrop (value, standard) {
            if (
                standard &&
                standard.guid
            ) {
                if (_.find(this.selected_standards, {guid: standard.guid})) {
                    this.$bvToast.toast('Standard already linked', {
                        // title: 'Note',
                        variant: 'warning',
                        solid: false,
                        autoHideDelay: 3000,
                        appendToast: true
                    })
                } else {
                    this.addStandard(standard)
                }
            }
        },
        highlightDropArea (value, standard) {
            if (
                standard &&
                standard.guid
            ) {
                this.$set(value, 'highlight', true)
            }
        },
        unhighlightDropArea (value) {
            this.$set(value, 'highlight', false)
        }
    }
}
</script>
